import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var CaretRightIcon = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Caret Right Icon" : _b, props = __rest(_a, ["ariaLabel"]);
    return (React.createElement(SvgIcon, __assign({}, props, { ariaLabel: ariaLabel }),
        React.createElement("path", { d: "M8 6.21a.712.712 0 000 1.01L10.78 10 8 12.78a.713.713 0 101.01 1.01l3.288-3.288c.28-.28.28-.73 0-1.01L9.01 6.203A.72.72 0 008 6.21z" })));
};

export { CaretRightIcon };
//# sourceMappingURL=CaretRightIcon.esm.js.map
